import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../custom/CustomInput";
import CustomSelect from "../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../loader/CircularIndeterminate";

const AjivasanDemo = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const payuPayment = {
      id: values.id,
      name: values.clientname,
      email: values.clientemail,
      amount: values.clientphone,
      // student_no: values.student_no,
      // is_online_payment: values.is_online_payment,
      // is_enquiry: values.is_enquiry,
      // course_id: values.course_id, 
    };
    dispatch(
      actions.postPayuPaymentData(payuPayment, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white p-3">
          <Row>
            <h5 className="text-center p-3">Book a Pass (General)</h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  id: "1",
                  clientname: "",
                  clientemail: "",
                  clientphone: "1",

                  // student_no: "",
                  // is_online_payment: "0",
                  // is_enquiry: "1",
                  // course_id: "295",
                  // checked: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  // clientemail: Yup.string()
                  //   .required("Enter Your Email")
                  //   .email("Invalid Email address"),
                  // clientname: Yup.string().required("required"),
                  // clientphone: Yup.string().required("required"),
                  // student_no: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  console.log("formProps.values", formProps.values);
                  return (
                    <Form className="mt-3">
                      {console.log("formProps music", formProps.values)}
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientname" className="label">
                            Your Full Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="clientphone" className="label">
                            Your Amount:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {/* <Row className="form-group mt-3">
                        <Col md={12}>
                          <Label htmlFor="student_no" className="label">
                            Number of Passes:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="student_no"
                              id="student_no"
                              placeholder="Enter Number of Passes"
                              className={
                                "form-control" +
                                (formProps.errors.student_no &&
                                formProps.touched.student_no
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select No.of Passes</option>
                              <option value={"1"}>1</option>
                              <option value={"2"}>2</option>
                              <option value={"3"}>3</option>
                              <option value={"4"}>4</option>
                              <option value={"5"}>5</option>
                            </Field>
                            <ErrorMessage
                              name="student_no"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <InputGroup>
                            <Field
                              type="checkbox"
                              name="checked"
                              value="1"
                              required
                            />

                            <span className="radiobtn">
                              {" "}
                              &nbsp;I agree with Terms & Conditions *
                            </span>
                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row> */}

                      <div className="mt-3 mb-3 row mt-5">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default AjivasanDemo;
